import React, { useEffect } from 'react';
import { Field, Formik } from 'formik';
import * as yup from 'yup';
import i18next from 'i18next';
import { RiDeleteBin5Line } from 'react-icons/ri';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import TextInput from '../../components/Shared/TextInput';
import PageHeader from '../../components/Shared/PageHeader'
import SharedButton from '../../components/Shared/SharedButton';
import DropdownComponent from '../../components/Shared/DropdownComponent';
import { getPriceListByID } from '../../store/slices/ItemSlice';
import { CreateNewPurchasedEntry, getPurchasedEntryList, getVendors } from '../../store/slices/PurchaseSlice';
import CustomSearchInput from '../../components/Shared/CustomSearchInput';
import DatePicker from '../../components/Shared/DatePicker';
import { InputSwitch } from 'primereact/inputswitch';
import { FaCheckDouble } from 'react-icons/fa6';

export default function CreatePurchasedEntryPage() {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const lang = i18next.language;
  const { isLoading } = useSelector(state => state.purchase);
  const { items } = useSelector(state => state.item);
  const { vendors } = useSelector(state => state.purchase);

  const expenseAccountsOptionsFromat = accountsData => {
    let options = accountsData.map(account => {
      return {
        value: Number(account?.code),
        label: lang === 'ar' ? account?.name_ar + ' ' + account?.code : account?.name_en + ' ' + account?.code
      };
    });
    return options;
  };

  useEffect(() => {
    dispatch(getPriceListByID({ payer_id: '0' }));
    dispatch(getVendors());
  }, []);

  function convertData(inputData) {
    return Object.values(inputData).map(item => ({
      value: item.ID,
      label: lang === 'ar' ? item?.name_ar : item?.name_en,
      price: item.price,
      name_en: item?.name_en || "",
      name_ar: item?.name_ar || "",
      item_code: item?.non_standard_code || item?.item_code || "",
      non_standard_code: item?.non_standard_code
    }));
  }
  const ItemsOptions = convertData(items.data || []);

  function vendor(inputData) {
    return Object.values(inputData).map(item => ({
      value: item?.id,
      label: item?.name
    }));
  }

  const taxCheckOptions = [
    { value: true, label_en: 'Yes', label_ar: 'نعم' },
    { value: false, label_en: 'No', label_ar: 'لا' }
  ];
  const getTaxCheckOptions = lang => {
    return taxCheckOptions.map(option => ({
      value: option.value,
      label: lang === 'ar' ? option.label_ar : option.label_en
    }));
  };

  const unitTypeOptions = [
    { value: 'ml', label_en: 'ml', label_ar: 'ml' },
    { value: 'Box', label_en: 'Box', label_ar: 'box' },
    { value: 'Unit', label_en: 'Unit', label_ar: 'unit' },
    { value: 'vial', label_en: 'vial', label_ar: 'vial' },

    { value: 'Syringe', label_en: 'Syringe', label_ar: 'Syringe' },
    { value: 'Service', label_en: 'Service', label_ar: 'خدمة' },

    { value: 'Piece', label_en: 'Piece', label_ar: 'قطعة' },
    { value: 'Dozen', label_en: 'Dozen', label_ar: 'دزينة' },
    { value: 'Kilogram', label_en: 'Kilogram', label_ar: 'كيلوجرام' },
    { value: 'Gram', label_en: 'Gram', label_ar: 'جرام' },

    { value: 'Ton', label_en: 'Ton', label_ar: 'طن' },
    { value: 'Liter', label_en: 'Liter', label_ar: 'لتر' },
    { value: 'Milliliter', label_en: 'Milliliter', label_ar: 'ملليلتر' },
    { value: 'Gallon', label_en: 'Gallon', label_ar: 'جالون' },
    { value: 'Meter', label_en: 'Meter', label_ar: 'متر' },
    { value: 'Centimeter', label_en: 'Centimeter', label_ar: 'سنتيمتر' },
    { value: 'Inch', label_en: 'Inch', label_ar: 'بوصة' },
    { value: 'Foot', label_en: 'Foot', label_ar: 'قدم' },
    { value: 'Pack', label_en: 'Pack', label_ar: 'عبوة' },
    { value: 'Carton', label_en: 'Carton', label_ar: 'كرتون' },
    { value: 'Bag', label_en: 'Bag', label_ar: 'كيس' },
  ];
  const getUnitTypeOptions = lang => {
    return unitTypeOptions.map(option => ({
      value: option.value,
      label: lang === 'ar' ? option.label_ar : option.label_en
    }));
  };

  const discountTypeOptions = [
    { value: 'Fixed', label_en: 'Fixed', label_ar: 'ثابت' },
    { value: 'Percentage', label_en: 'Percentage', label_ar: 'نسبة مئوية' }
  ];

  const getDiscountTypeOptions = lang => {
    return discountTypeOptions.map(option => ({
      value: option.value,
      label: lang === 'ar' ? option.label_ar : option.label_en
    }));
  };

  const initialValues = {
    vendor_id: '',
    purchase_date: null,
    notes: '',
    refrence: '',
    items: []
  };

  const validationSchema = yup.object().shape({
    vendor_id: yup.number().required(t('required')),
    purchase_date: yup.string().required(t('required')),
    // notes: yup.string().required(t('required')),
    refrence: yup.string().required(t('required')),
    items: yup
      .array()
      .of(
        yup.object().shape({
          price: yup.string().required(t('required')),
          // account_code: yup.number().required(t("required")),
          discount_type: yup.string(),
          discount_amount: yup.number()
            .required(t('required'))
            .when('discount_type', {
              is: 'Percentage',
              then: (schema) => schema.max(100, t('maxlimit') + ' 100'),
              otherwise: (schema) => schema
            }),
          batch_number: yup.string(),
          expiry_date: yup.string(),
          tax_check: yup.bool().required(t('required')),
          bonus: yup.number().required(t('required'))
        })
      )
      .min(1, t('required'))
  });

  return (
    <div>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={async (data, { resetForm }) => {
          // Helper function to format date to YYYY-MM-DD
          const formatDate = (date) => {
            if (date instanceof Date) {
              const year = date.getFullYear();
              const month = String(date.getMonth() + 1).padStart(2, '0');
              const day = String(date.getDate()).padStart(2, '0');
              return `${year}-${month}-${day}`;
            }
            return date;
          };

          const payload = {
            ...data,
            purchase_date: formatDate(data.purchase_date),
            items: data.items.map(item => {
              const price = Number(item?.price) || 0;
              const quantity = Number(item?.quantity) || 0;
              const bonus = Number(item?.bonus) || 0;
              const discountAmount = Number(item?.discount_amount) || 0;
              const discountType = item?.discount_type || 'Percentage';

              let priceAfterDiscount = 0;
              if (discountType === 'Fixed') {
                priceAfterDiscount = price - discountAmount;
              } else {
                priceAfterDiscount = price - (price * discountAmount / 100);
              }

              const netTotal = priceAfterDiscount * quantity;
              const vat = item.tax_check ? netTotal * 0.15 : 0;
              const publicUnitPrice = netTotal + vat;

              return {
                ...item,
                expiry_date: formatDate(item.expiry_date),
                discount_amount: discountAmount,
                price: price,
                quantity: quantity,
                bonus: bonus,
                public_unit_price: Number(publicUnitPrice.toFixed(2))
              };
            })
          };
          const resultAction = await dispatch(CreateNewPurchasedEntry(payload));
          if (CreateNewPurchasedEntry.fulfilled.match(resultAction)) {
            navigate('/manager/purchased_entry');
            resetForm();
            dispatch(getPurchasedEntryList({ page: 1, per_page: 10 }));
          }
        }}
        validateOnChange={true}
        validateOnBlur={true}
        validate={values => {
          validationSchema
            .validate(values, { abortEarly: false })
            .then(() => console.log('Validation passed'))
            .catch(err => console.log('Validation errors:', err.errors));
        }}
      >
        {props => (
          <form onSubmit={props.handleSubmit}>
            <div className='flex flex-col w-full gap-2'>
              <PageHeader title={t('CreatePurchasedEntry')} backPath={'/manager/purchased_entry'} />

              <div className='grid grid-cols-1 md:grid-cols-4 gap-2 w-full'>
                <CustomSearchInput
                  name='vendor_id'
                  placeholder={`${t('select')} ${t('vendor')}`}
                  options={vendor(vendors || [])}
                  label={t('vendors')}
                  className={'!w-full'}
                />
                <DatePicker
                  label={t('purchase_date')}
                  name={'purchase_date'}
                  placeholder={t('enter_purchase_date')}
                  dateFormat="yy-mm-dd"
                />

                <TextInput
                  label={t('invoice_number')}
                  name={'refrence'}
                  placeholder={t("invoice_number_placeholder")}
                />

                <TextInput
                  label={t('notes')}
                  name={'notes'}
                  placeholder={t("enter_notes")}
                />
              </div>

              <div className='flex items-end gap-2'>
                <div className='mt-4 w-full'>
                  <CustomSearchInput
                    label={t('items')}
                    name={'items'}
                    options={ItemsOptions}
                    placeholder={`${t('select')} ${t('items')}`}
                    className='!w-full'
                    onChange={selectedOption => {
                      const selectedItem = ItemsOptions.find(item => item.value === selectedOption.value);
                      if (selectedItem) {
                        const newItem = {
                          item_id: selectedItem?.value,
                          item_code: selectedItem?.non_standard_code || selectedItem?.item_code || '',
                          name_en: selectedItem.name_en,
                          name_ar: selectedItem.name_ar,
                          price: selectedItem?.price || 0,
                          unit: '0',
                          quantity: 1,
                          discount_amount: 0,
                          discount_type: 'Percentage',
                          batch_number: '',
                          expiry_date: new Date(),
                          tax_check: true,
                          bonus: 0
                        };
                        props.setFieldValue('items', [...props.values.items, newItem]);
                      }
                    }}
                  />
                </div>
              </div>

              <div className='mt-4'>
                {props?.values?.items?.length > 0 && (
                  <div className='mt-2 max-h-[350px] overflow-auto'>
                    <table className='w-full mt-2 border rounded-md border-gray-200 whitespace-nowrap'>
                      <thead className='rounded'>
                        <tr>
                          <th className='table-header bg-gray-300 !font-bold w-[120px]'>{t('item_code')}</th>
                          <th className='table-header bg-gray-300 !font-bold min-w-[250px] md:w-[250px]'>{t('name')}</th>
                          <th className='table-header bg-gray-300 !font-bold min-w-[100px] md:w-[100px]'>{t('Batch')}</th>
                          <th className='table-header bg-gray-300 !font-bold min-w-[120px] md:w-[120px]'>{t('Expiry')}</th>
                          <th className='table-header bg-gray-300 !font-bold min-w-[100px] md:w-[100px]'>{t('unit')}</th>
                          <th className='table-header bg-gray-300 !font-bold min-w-[80px] md:w-[80px]'>{t('unitPrice')}</th>
                          <th className='table-header bg-gray-300 !font-bold min-w-[120px] md:w-[120px]'>{t('Disc. Type')}</th>
                          <th className='table-header bg-gray-300 !font-bold min-w-[50px] md:w-[50px]'>{t('Disc')}</th>
                          <th className='table-header bg-gray-300 !font-bold min-w-[50px] md:w-[50px]'>{t('Qty')}</th>
                          <th className='table-header bg-gray-300 !font-bold min-w-[50px] md:w-[50px]'>{t('bonus')}</th>
                          <th className='table-header bg-gray-300 !font-bold min-w-[80px] md:w-[80px]'>{t('tax_15')}</th>
                          <th className='table-header bg-gray-300 !font-bold min-w-[100px] md:w-[100px]'>{t('total_amount')}</th>
                          <th className='table-header bg-gray-300 !font-bold min-w-[50px] md:w-[50px]'>{t('actions')}</th>
                        </tr>
                      </thead>
                      <tbody className='rounded'>
                        {props.values.items.map((item, index) => (
                          <tr key={index} className='border-t'>
                            <td className='!px-[0.35rem] !py-[0.6rem]'>
                              <Field
                                name={`items[${index}].item_code`}
                                as={TextInput}
                                type='text'
                                placeholder={`${t('enter')} ${t('item_code')}`}
                                className='!p-1.5'
                                value={item?.item_code}
                                onChange={e => {
                                  const newItems = [...props?.values?.items];
                                  newItems[index].item_code = e.target.value || "";
                                  props.setFieldValue('items', newItems);
                                }}
                              />
                            </td>
                            <td className='!px-[0.35rem] !py-[0.6rem]'>
                              <Field
                                name={`items[${index}].name`}
                                as={TextInput}
                                type='text'
                                placeholder={`${t('enter')} ${t('name')}`}
                                className='!p-1.5'
                                value={item?.name_en}
                                onChange={e => {
                                  const newItems = [...props?.values?.items];
                                  newItems[index].name_en = e.target.value || '';
                                  props.setFieldValue('items', newItems);
                                }}
                              />
                            </td>
                            <td className='!px-[0.35rem] !py-[0.6rem]'>
                              <Field
                                name={`items[${index}].batch_number`}
                                as={TextInput}
                                type='text'
                                placeholder={`${t('enter')} ${t('Batch')}`}
                                className='!p-1.5'
                                value={item?.batch_number}
                                onChange={e => {
                                  const newItems = [...props.values.items];
                                  newItems[index].batch_number = e.target.value;
                                  props.setFieldValue('items', newItems);
                                }}
                              />
                            </td>
                            <td className='!px-[0.35rem] !py-[0.6rem]'>
                              <DatePicker
                                name={`items[${index}].expiry_date`}
                                placeholder={`${t('enter')} ${t('Expiry')}`}
                              // dateFormat="ddyy-mm-"
                              />
                            </td>
                            <td className='!px-[0.35rem] !py-[0.6rem]'>
                              <DropdownComponent
                                filter
                                name={`items[${index}].unit`}
                                options={getUnitTypeOptions(lang)}
                                placeholder={t('select')}
                              />
                            </td>
                            <td className='!px-[0.35rem] !py-[0.6rem]'>
                              <Field
                                name={`items[${index}].price`}
                                as={TextInput}
                                type='string'
                                placeholder={t("price_placeholder")}
                                className='!p-1.5'
                                value={item?.price || ''}
                                onBlur={e => {
                                  const value = e?.target?.value;
                                  const newItems = [...props.values.items];
                                  newItems[index].price = value && value > 1 && !isNaN(value) ? value : 1;
                                  props.setFieldValue('items', newItems);
                                }}
                                onChange={e => {
                                  const value = e?.target?.value;
                                  const newItems = [...props.values.items];
                                  newItems[index].price = value && !isNaN(value) ? value : 0;
                                  props.setFieldValue('items', newItems);
                                }}
                              />
                            </td>
                            <td className='!px-[0.35rem] !py-[0.6rem]'>
                              <DropdownComponent
                                name={`items[${index}].discount_type`}
                                options={getDiscountTypeOptions(lang)}
                                value={item.discount_type || 'Percentage'}
                                onChange={e => {
                                  const newItems = [...props.values.items];
                                  newItems[index].discount_type = e.target.value;
                                  newItems[index].discount_amount = 0;
                                  props.setFieldValue('items', newItems);
                                }}
                              />
                            </td>
                            <td className='!px-[0.35rem] !py-[0.6rem]'>
                              <Field
                                name={`items[${index}].discount_amount`}
                                as={TextInput}
                                type='text'
                                placeholder={`${t('enter')} ${t('amount')}`}
                                className='!p-1.5'
                                value={item.discount_amount}
                                onChange={e => {
                                  let value = e.target.value;
                                  if (value.length > 1 && value.startsWith('0') && value[1] !== '.') {
                                    value = value.substring(1);
                                  }
                                  const newItems = [...props.values.items];
                                  if (value === '' || !isNaN(value)) {
                                    newItems[index].discount_amount = value || 0;
                                    props.setFieldValue('items', newItems);
                                  }
                                }}
                              />
                            </td>
                            <td className='!px-[0.35rem] !py-[0.6rem]'>
                              <Field
                                name={`items[${index}].quantity`}
                                as={TextInput}
                                type='number'
                                placeholder={`${t('enter')} ${t('Qty')}`}
                                className='!p-1.5'
                                value={item.quantity}
                                onChange={e => {
                                  const newItems = [...props.values.items];
                                  newItems[index].quantity = Number(e.target.value);
                                  props.setFieldValue('items', newItems);
                                }}
                              />
                            </td>
                            <td className='!px-[0.35rem] !py-[0.6rem]'>
                              <Field
                                name={`items[${index}].bonus`}
                                as={TextInput}
                                type='number'
                                placeholder={`${t('enter')} ${t('bonus')}`}
                                className='!p-1.5'
                                value={item.bonus}
                                onChange={e => {
                                  const newItems = [...props.values.items];
                                  newItems[index].bonus = Number(e.target.value);
                                  props.setFieldValue('items', newItems);
                                }}
                              />
                            </td>
                            <td className='!px-[0.35rem] !py-[0.6rem]'>
                              <InputSwitch
                                checked={item.tax_check}
                                onChange={(e) => {
                                  const newItems = [...props.values.items];
                                  newItems[index].tax_check = e.value;
                                  props.setFieldValue('items', newItems);
                                }}
                                pt={{ slider: { className: item.tax_check ? 'bg-primary' : '' } }}
                              />
                            </td>
                            <td className='!px-[0.35rem] !py-[0.6rem]'>
                              <TextInput
                                disabled={true}
                                name={`items[${index}].public_unit_price`}
                                value={(() => {
                                  const price = Number(item.price) || 0;
                                  const quantity = Number(item.quantity) || 0;
                                  const discountAmount = Number(item.discount_amount) || 0;

                                  let priceAfterDiscount = 0;
                                  if (item.discount_type === 'Fixed') {
                                    priceAfterDiscount = price - discountAmount;
                                  } else {
                                    priceAfterDiscount = price - (price * discountAmount / 100);
                                  }

                                  const netTotal = priceAfterDiscount * quantity;
                                  const vat = item.tax_check ? netTotal * 0.15 : 0;

                                  return (netTotal + vat).toFixed(2);
                                })()}
                                className='!p-1.5'
                              />
                            </td>
                            <td className='!px-[0.35rem] !py-[0.6rem]'>
                              <div className='flex justify-center items-center h-full'>
                                <RiDeleteBin5Line
                                  size={20}
                                  className='cursor-pointer text-red-500'
                                  onClick={() => {
                                    const newItems = props.values.items.filter((_, i) => i !== index);
                                    props.setFieldValue('items', newItems);
                                  }}
                                />
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
                {props.errors.items && typeof props.errors.items === 'object' && !Array.isArray(props.errors.items) && (
                  <div className='text-red-500 text-sm mt-1'>{props.errors.items}</div>
                )}
              </div>

              {props?.values?.items?.length > 0 && (() => {
                const calculations = props.values.items?.reduce((acc, item) => {
                  const price = Number(item?.price) || 0;
                  const quantity = Number(item?.quantity) || 0;
                  const discountValue = Number(item?.discount_amount) || 0;
                  const discountType = item?.discount_type || 'Percentage';
                  const hasTax = item?.tax_check;

                  const lineTotal = price * quantity;

                  let discountAmount = 0;
                  if (discountType === 'Fixed') {
                    discountAmount = discountValue * quantity;
                  } else {
                    // Percentage
                    discountAmount = (lineTotal * discountValue) / 100;
                  }

                  const lineNet = lineTotal - discountAmount;
                  const lineTax = hasTax ? lineNet * 0.15 : 0;

                  acc.totalPublicPrice += lineTotal;
                  acc.totalDiscount += discountAmount;
                  acc.totalVat += lineTax;
                  return acc;
                }, { totalPublicPrice: 0, totalDiscount: 0, totalVat: 0 });

                const totalAfterDiscount = calculations?.totalPublicPrice - calculations?.totalDiscount;
                const finalTotal = totalAfterDiscount + calculations?.totalVat;
                const vatPercentage = totalAfterDiscount ? ((calculations?.totalVat / totalAfterDiscount) * 100) : 0;

                return (
                  <div className="flex justify-end mt-4">
                    <div className="bg-white p-4 rounded-lg border border-gray-200 w-full md:w-1/4 space-y-3">
                      <div className="flex justify-between items-center text-gray-800">
                        <span className="font-medium">{t('Total Unit Price')}:</span>
                        <span className="font-semibold">{calculations?.totalPublicPrice.toFixed(2)}</span>
                      </div>
                      <div className="flex justify-between items-center text-gray-800">
                        <span className="font-medium">{t('Discount')}:</span>
                        <span className="font-semibold">{calculations?.totalDiscount.toFixed(2)}</span>
                      </div>
                      <div className="flex justify-between items-center text-gray-800">
                        <span className="font-medium">{t('Total After Discount')}:</span>
                        <span className="font-semibold">{totalAfterDiscount?.toFixed(2)}</span>
                      </div>
                      <div className="flex justify-between items-center text-gray-800">
                        <span className="font-medium">{t('VAT')}:</span>
                        <span className="font-semibold">{calculations?.totalVat.toFixed(2)}</span>
                      </div>
                      <div className="border-t pt-3 flex justify-between items-center text-lg">
                        <span className="font-semibold text-gray-800">{t('Grand Total')}:</span>
                        <span className="font-semibold text-primary">{finalTotal?.toFixed(2)}</span>
                      </div>
                    </div>
                  </div>
                );
              })()}

              <div className='flex justify-end gap-2 mt-4'>
                <SharedButton
                  disabled={isLoading}
                  icon='pi pi-times'
                  label={t('Cancel')}
                  buttonType='reset'
                  onClick={() => {
                    navigate('/manager/purchased_entry');
                    props.resetForm();
                  }}
                />
                <SharedButton
                  icon={<FaCheckDouble size={12} className='me-2' />}
                  label={t('Submit')}
                  loading={isLoading}
                  className='submit-btn'
                  type='submit'
                />
              </div>
            </div>
          </form>
        )}
      </Formik>
    </div>
  );
}
